'use strict';
import Config from './config';
import Func from './_func';
import $ = require("jquery");

namespace Seminar {
    export class MySeminar {
        constructor() {
            let self = this;

            $('.bulletGuideContent').hide();
            $('.bulletConductContent').hide();
            $('.bulletApplicationContent').hide();
            $('.bulletContactContent').hide();

            $('.trigGuideContent').on('click', () => {
                const openFlag = Number( $('.paramGuideContent').attr('data-open') );
                if(openFlag == 0) {
                    $('.trigGuideContent').find('i').addClass('fa-minus');
                    $('.trigGuideContent').find('i').removeClass('fa-plus');
                    $('.bulletGuideContent').slideDown('slow', function() {
                        $('.paramGuideContent').attr('data-open', 1);
                    });
                } else {
                    $('.trigGuideContent').find('i').addClass('fa-plus');
                    $('.trigGuideContent').find('i').removeClass('fa-minus');
                    $('.bulletGuideContent').slideUp('slow', function() {
                        $('.paramGuideContent').attr('data-open', 0);
                    });
                }
            });

            $('.trigConductContent').on('click', () => {
                const openFlag = Number( $('.paramConductContent').attr('data-open') );
                if(openFlag == 0) {
                    $('.trigConductContent').find('i').addClass('fa-minus');
                    $('.trigConductContent').find('i').removeClass('fa-plus');
                    $('.bulletConductContent').slideDown('slow', function() {
                        $('.paramConductContent').attr('data-open', 1);
                    });
                } else {
                    $('.trigConductContent').find('i').addClass('fa-plus');
                    $('.trigConductContent').find('i').removeClass('fa-minus');
                    $('.bulletConductContent').slideUp('slow', function() {
                        $('.paramConductContent').attr('data-open', 0);
                    });
                }
            });

            $('.trigApplicationContent').on('click', () => {
                const openFlag = Number( $('.paramApplicationContent').attr('data-open') );
                if(openFlag == 0) {
                    $('.trigApplicationContent').find('i').addClass('fa-minus');
                    $('.trigApplicationContent').find('i').removeClass('fa-plus');
                    $('.bulletApplicationContent').slideDown('slow', function() {
                        $('.paramApplicationContent').attr('data-open', 1);
                    });
                } else {
                    $('.trigApplicationContent').find('i').addClass('fa-plus');
                    $('.trigApplicationContent').find('i').removeClass('fa-minus');
                    $('.bulletApplicationContent').slideUp('slow', function() {
                        $('.paramApplicationContent').attr('data-open', 0);
                    });
                }
            });

            $('.trigContactContent').on('click', () => {
                const openFlag = Number( $('.paramContactContent').attr('data-open') );
                if(openFlag == 0) {
                    $('.trigContactContent').find('i').addClass('fa-minus');
                    $('.trigContactContent').find('i').removeClass('fa-plus');
                    $('.bulletContactContent').slideDown('slow', function() {
                        $('.paramContactContent').attr('data-open', 1);
                    });
                } else {
                    $('.trigContactContent').find('i').addClass('fa-plus');
                    $('.trigContactContent').find('i').removeClass('fa-minus');
                    $('.bulletContactContent').slideUp('slow', function() {
                        $('.paramContactContent').attr('data-open', 0);
                    });
                }
            });

            $('.trigCloseModal').on('click', () => {
                $('.bulletModalWindow').fadeOut('slow', function() {
                    $('.paramModalWindow').attr('data-show', 0);
                });
            });

            $('.trigOpenA').on('click', () => {
                $('.bulletCourse').hide();
                $('.bulletOpenA').show();
                $('.bulletModalWindow').fadeIn('slow', function() {
                    $('.paramModalWindow').attr('data-show', 1);
                });
            })

            $('.trigOpenB').on('click', () => {
                $('.bulletCourse').hide();
                $('.bulletOpenB').show();
                $('.bulletModalWindow').fadeIn('slow', function() {
                    $('.paramModalWindow').attr('data-show', 1);
                });
            })

            $('.trigOpenC').on('click', () => {
                $('.bulletCourse').hide();
                $('.bulletOpenC').show();
                $('.bulletModalWindow').fadeIn('slow', function() {
                    $('.paramModalWindow').attr('data-show', 1);
                });
            })
        }

        public changeRegistrationValue(checked): void {
            if(checked == 0){
                $('#paramChangeRegistration').val(0);
            }else{
                $('#paramChangeRegistration').val(1);
            }
        }

    }
}
export default Seminar;